// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"cd3c2839","644":"4c05209d"}[chunkId] + ".chunk.js";
};